import React from "react";
import style from "./BoxContainer.module.css";
import more from "../../../assets/icons/learnMore.svg";
import { useState } from "react";

const BoxContainer = ({ index,image, title, mainContent }) => {
  const [showContent, setShowContent] = useState(false);

  const show = () => {
    setShowContent(true);
  };

  const hide = () => {
    setShowContent(false);
  };
  return (
    <div className={style.boxCon} onMouseEnter={show} onMouseLeave={hide}>
      <img
        className={`${style.logo} ${style.row} ${style.row1}`}
        src={image}
        alt=""
        draggable={false}
      />
      <span className={`${style.title} ${style.row} ${style.row2}`}>
        {title}
      </span>
      {showContent && (
        <span className={`${style.content} ${style.row} ${style.row3}`}>
          {mainContent}
        </span>
      )}
      {/* <button tabIndex={-1} className={`${style.buttonContainer} ${style.row4}`}>
        <img src={more} alt="" draggable={false}/>
        <span>Step {index + 1}</span>
      </button> */}
    </div>
  );
};

export default BoxContainer;
